import { roundMetric } from "../hooks/useTaskBonusTotals.js";
import { CRITERIOS_DESAFIO_LEGADO, MERITOS_DEF } from "./constants";
export const uid = () => Date.now() + Math.floor(Math.random() * 9999);
const toLocalISODate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};
const addDaysLocal = (date, days) => {
  const next = new Date(date);
  next.setDate(next.getDate() + days);
  return next;
};
export const todayISO = () => toLocalISODate(new Date());
export const fmtDate = (iso) => {
  const [, splitResult, splitResultAtual2] = iso.split("-");
  return `${splitResultAtual2}/${splitResult}`;
};
export const fmtDateFull = (iso) => {
  const [splitResult, splitResultAtual2, splitResultAtual3] = iso.split("-");
  return `${splitResultAtual3}/${splitResultAtual2}/${splitResult}`;
};
export const fmtNum = (valueAtual2, dec = 0) => {
  const value = Number(valueAtual2);
  const safeValue = Number.isFinite(value) ? value : 0;
  return safeValue.toLocaleString("pt-BR", {
    minimumFractionDigits: dec,
    maximumFractionDigits: dec,
  });
};
export const tempoRel = (value) => {
  const valueAtual2 = (Date.now() - value) / 1000;
  if (valueAtual2 < 60) return "agora";
  if (valueAtual2 < 3600) return Math.floor(valueAtual2 / 60) + "min";
  if (valueAtual2 < 86400) return Math.floor(valueAtual2 / 3600) + "h";
  return Math.floor(valueAtual2 / 86400) + "d";
};
const YOUTUBE_HOSTS = new Set([
  "youtube.com",
  "www.youtube.com",
  "m.youtube.com",
  "music.youtube.com",
  "youtu.be",
  "www.youtu.be",
  "youtube-nocookie.com",
  "www.youtube-nocookie.com",
]);
const parseYoutubeTimeToSeconds = (value) => {
  const raw = String(value || "")
    .trim()
    .toLowerCase();
  if (!raw) return "";
  if (/^\d+$/.test(raw)) {
    return raw;
  }
  const match = raw.match(/^(?:(\d+)h)?(?:(\d+)m)?(?:(\d+)s)?$/);
  if (!match) {
    return "";
  }
  const hours = Number(match[1] || 0);
  const minutes = Number(match[2] || 0);
  const seconds = Number(match[3] || 0);
  const totalSeconds = hours * 3600 + minutes * 60 + seconds;
  return totalSeconds > 0 ? String(totalSeconds) : "";
};
export const normalizeVideoEmbedUrl = (value) => {
  const rawValue = String(value || "").trim();
  if (!rawValue) return "";
  const iframeMatch = rawValue.match(/src=["']([^"']+)["']/i);
  const sourceValue = iframeMatch?.[1] || rawValue;
  try {
    const url = new URL(sourceValue);
    const host = url.hostname.toLowerCase();
    if (!YOUTUBE_HOSTS.has(host)) {
      return sourceValue;
    }
    const pathParts = url.pathname.split("/").filter(Boolean);
    let videoId = "";
    if (host.includes("youtu.be")) {
      videoId = pathParts[0] || "";
    } else if (["embed", "shorts", "live", "v"].includes(pathParts[0])) {
      videoId = pathParts[1] || "";
    } else {
      videoId = url.searchParams.get("v") || "";
    }
    if (!videoId) {
      return sourceValue;
    }
    const embedUrl = new URL(`https://www.youtube.com/embed/${videoId}`);
    const startValue =
      url.searchParams.get("start") ||
      parseYoutubeTimeToSeconds(url.searchParams.get("t"));
    const listValue = url.searchParams.get("list");
    if (startValue) {
      embedUrl.searchParams.set("start", startValue);
    }
    if (listValue) {
      embedUrl.searchParams.set("list", listValue);
    }
    embedUrl.searchParams.set("rel", "0");
    return embedUrl.toString();
  } catch {
    return sourceValue;
  }
};
export const iniSemana = () => toLocalISODate(addDaysLocal(new Date(), -7));
export const iniMes = () => toLocalISODate(addDaysLocal(new Date(), -30));
const normalizeMetricType = (value) =>
  String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();
const isCheckpointValid = (checkpoint) =>
  normalizeMetricType(checkpoint?.status_questao) !== "invalido";
export function calcStreak(alunoId, checkpoints) {
  const alunoIdNum = Number(alunoId);
  const dias = new Set(
    checkpoints
      .filter(
        (checkpoint) =>
          Number(checkpoint.aluno_id) === alunoIdNum &&
          isCheckpointValid(checkpoint) &&
          (!Array.isArray(checkpoint.itens) ||
            checkpoint.itens.some((item) => Number(item.quantidade) > 0)),
      )
      .map((item) => item.data_estudo),
  );
  const previousDay = (iso) => {
    const [ano, mes, dia] = iso.split("-").map(Number);
    return new Date(Date.UTC(ano, mes - 1, dia - 1)).toISOString().slice(0, 10);
  };
  // Como no perfil, a sequência continua valendo até o fim do dia de hoje.
  let ref = todayISO();
  if (!dias.has(ref)) ref = previousDay(ref);
  let streak = 0;
  while (dias.has(ref)) {
    streak += 1;
    ref = previousDay(ref);
  }
  return streak;
}
export function calcStats(
  alunoId,
  checkpoints,
  batalhas = [],
  activities = [],
  checkpointsComAutomaticos = checkpoints,
) {
  const alunoIdNum = Number(alunoId);
  const activityById = new Map(
    (activities || []).map((item) => [Number(item.id), item]),
  );
  const meusCps = checkpoints.filter(
    (checkpoint) =>
      Number(checkpoint.aluno_id) === alunoIdNum &&
      isCheckpointValid(checkpoint),
  );
  const checkpointsPorAtividade = {};
  meusCps.forEach((meusCp) => {
    new Set(
      (meusCp.itens || [])
        .filter((item) => Number(item.quantidade) > 0)
        .map((item) => Number(item.tipo_id)),
    ).forEach((activityId) => {
      checkpointsPorAtividade[activityId] =
        (checkpointsPorAtividade[activityId] || 0) + 1;
    });
  });
  const meusCpsComAutomaticos = (
    checkpointsComAutomaticos || checkpoints
  ).filter(
    (item) => Number(item.aluno_id) === alunoIdNum && isCheckpointValid(item),
  );
  let horas = 0;
  let horasSemana = 0;
  let questoes = 0;
  let questoesSemana = 0;
  let resumos = 0;
  let videoaula = 0;
  let indicacoes = 0;
  let pontos = 0;
  const sem = iniSemana();
  meusCpsComAutomaticos.forEach((meusCpsComAutomatico) => {
    const naSemana = meusCpsComAutomatico.data_estudo >= sem;
    (meusCpsComAutomatico.itens || []).forEach((item) => {
      const tipoId = Number(item.tipo_id);
      const atividade = activityById.get(tipoId);
      const qtd = Number(item.quantidade || 0);
      if (!Number.isFinite(qtd) || qtd <= 0) return;
      if (
        "hora" === String(atividade?.unidade || "").toLowerCase() ||
        [1, 4].includes(tipoId)
      ) {
        horas += qtd;
        if (naSemana) {
          horasSemana += qtd;
        }
      }
    });
    pontos += Number(meusCpsComAutomatico.pontos_rank || 0);
  });
  meusCps.forEach((meusCp) => {
    const naSemana = meusCp.data_estudo >= sem;
    (meusCp.itens || []).forEach((item) => {
      const tipoId = Number(item.tipo_id);
      const atividade = activityById.get(tipoId);
      const qtd = Number(item.quantidade || 0);
      if (!Number.isFinite(qtd) || qtd <= 0) return;
      const unidade = String(atividade?.unidade || "").toLowerCase();
      if ("questao" === unidade || [2, 5].includes(tipoId)) {
        questoes += qtd;
        if (naSemana) {
          questoesSemana += qtd;
        }
      }
      if (!("unidade" !== unidade && 3 !== tipoId)) {
        resumos += qtd;
      }
      if ("pessoa" === unidade || [6, 7].includes(tipoId)) {
        indicacoes += qtd;
      }
      if ((atividade && 1 === Number(atividade.ordem)) || 1 === tipoId) {
        videoaula += qtd;
      }
    });
  });
  const streak = calcStreak(alunoId, checkpointsComAutomaticos);
  const desafiosVencidos = (batalhas || []).filter(
    (item) =>
      "finalizada" === item.status && Number(item.vencedor_id) === alunoIdNum,
  ).length;
  return {
    horas: roundMetric(horas, 2),
    horasSemana: roundMetric(horasSemana, 2),
    questoes: roundMetric(questoes, 2),
    questoesSemana: roundMetric(questoesSemana, 2),
    resumos: roundMetric(resumos, 2),
    videoaula: roundMetric(videoaula, 2),
    indicacoes: roundMetric(indicacoes, 2),
    pontos: roundMetric(pontos, 3),
    streak,
    checkpoints: meusCps.filter((meusCp) =>
      (meusCp.itens || []).some((item) => Number(item.quantidade) > 0),
    ).length,
    checkpointsPorAtividade,
    desafiosVencidos,
  };
}
export function getMeritos(
  alunoId,
  checkpoints,
  batalhas,
  meritosBase = [],
  activities = [],
  checkpointsComAutomaticos = checkpoints,
) {
  const calcStatsResult = calcStats(
    alunoId,
    checkpoints,
    batalhas,
    activities,
    checkpointsComAutomaticos,
  );
  const base =
    Array.isArray(meritosBase) && meritosBase.length > 0
      ? meritosBase
      : MERITOS_DEF;
  return base.map((item) => {
    const metricType = normalizeMetricType(item.tipo);
    const meta = Number(item.meta || 0);
    let prog = 0;
    if (metricType === "horas_total") prog = calcStatsResult.horas;
    if (metricType === "horas_semana") prog = calcStatsResult.horasSemana;
    if (metricType === "questoes_total") prog = calcStatsResult.questoes;
    if (metricType === "questoes_semana") prog = calcStatsResult.questoesSemana;
    if (metricType === "resumos_total") prog = calcStatsResult.resumos;
    if (metricType === "streak") prog = calcStatsResult.streak;
    if (metricType === "checkpoints_total") prog = calcStatsResult.checkpoints;
    if (metricType === "checkpoints_da_atividade")
      prog = calcStatsResult.checkpointsPorAtividade?.[Number(item.cat)] || 0;
    if (metricType === "pontos_total") prog = calcStatsResult.pontos;
    if (metricType === "indicacoes_total") prog = calcStatsResult.indicacoes;
    if (metricType === "desafios_vencidos")
      prog = calcStatsResult.desafiosVencidos;
    if (metricType === "videoaula_total") prog = calcStatsResult.videoaula;
    return {
      ...item,
      prog: Math.min(Number(prog || 0), meta),
      conquistado: Number(prog || 0) >= meta,
    };
  });
}
export function getLimiteLabel(activity) {
  if (!activity) return "";
  const parts = [];
  if (activity.max_token)
    parts.push(`max ${activity.max_token} tokens/${activity.periodo || "dia"}`);
  if (activity.max_pts)
    parts.push(`max ${activity.max_pts} pontos/${activity.periodo || "dia"}`);
  return parts.join(" | ");
}
export function calcularCriterio(
  criterioId,
  alunoId,
  dataInicio,
  dataFim,
  checkpoints,
  activities = [],
  checkpointsComAutomaticos = checkpoints,
) {
  // O contador automático de tempo estudado só gera itens sob o tipo_id da
  // própria atividade automática, então incluí-lo aqui não afeta os demais
  // critérios — é seguro usar sempre a base completa (feed + automático).
  const base = checkpointsComAutomaticos || checkpoints;
  const cpsFiltrados = base.filter(
    (item) =>
      Number(item.aluno_id) === Number(alunoId) &&
      item.data_estudo >= dataInicio &&
      item.data_estudo <= dataFim &&
      isCheckpointValid(item),
  );
  if (criterioId === "pontos") {
    return cpsFiltrados.reduce(
      (total, checkpoint) => total + Number(checkpoint.pontos_rank || 0),
      0,
    );
  }

  // Critério atual: id é o id real da atividade cadastrada em Pontuação.
  const activityId = Number(criterioId);
  if (Number.isFinite(activityId) && activityId > 0) {
    return cpsFiltrados.reduce(
      (total, checkpoint) =>
        total +
        (checkpoint.itens || [])
          .filter((item) => Number(item.tipo_id) === activityId)
          .reduce(
            (totalAtual2, item) => totalAtual2 + Number(item.quantidade || 0),
            0,
          ),
      0,
    );
  }

  // Fallback para desafios antigos, criados com os critérios fixos legados.
  const legado = CRITERIOS_DESAFIO_LEGADO.find(
    (criterio) => criterio.id === criterioId,
  );
  if (!legado) return 0;
  return cpsFiltrados.reduce(
    (total, checkpoint) =>
      total +
      (checkpoint.itens || [])
        .filter((item) => legado.tipo_ids.includes(Number(item.tipo_id)))
        .reduce(
          (totalAtual2, item) => totalAtual2 + Number(item.quantidade || 0),
          0,
        ),
    0,
  );
}
export const uuid = () => Math.random().toString(36).slice(2, 10);
export const clone = (value) => JSON.parse(JSON.stringify(value));
export const fileToDataUrl = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () =>
      reject(reader.error || new Error("Falha ao ler arquivo"));
    reader.readAsDataURL(file);
  });
export function getLessonBadges(aula) {
  return {
    video: Boolean(aula.videoUrl),
    texto: aula.guias.some((guia) =>
      guia.blocos.some((bloco) => bloco.tipo === "texto"),
    ),
    html: aula.guias.some((guia) =>
      guia.blocos.some((bloco) => bloco.tipo === "html" && bloco.html),
    ),
    anexo: aula.guias.some((guia) =>
      guia.blocos.some(
        (bloco) =>
          bloco.tipo === "anexo" &&
          Array.isArray(bloco.arquivos) &&
          bloco.arquivos.length,
      ),
    ),
  };
}
export { normalizeMetricType };
